import React from 'react'
import ReactDOM from 'react-dom'

class IFrame extends React.Component {
  render() {
    const {
      src,
      resizeDelay = 50
    } = this.props

    return (
      <>
        <iframe src={src}
                scrolling="no"
                frameBorder={0}
                width="100%"
                height="600px"
                onLoad={e => setTimeout(() => {
                  const obj = ReactDOM.findDOMNode(this)
                  obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px'
                }, resizeDelay)}/>
      </>
    )
  }
}

export {IFrame}

export default IFrame

